export const capitalize = (value = ''): string => value.charAt(0).toUpperCase() + value.slice(1);
export const fullCapitalize = (value = ''): string => value.toUpperCase();

export default {
  capitalize,
  fullCapitalize,
};
